import { Menu } from 'lucide-react';
import { memo } from 'react';

import { Button, Badge } from '@/components/design-system';
import {
  RADIUS_SCALE,
  COLOR_SCALE,
  TYPE_SCALE,
  SIZE_SCALE,
  SURFACE_PADDING,
} from '@/components/design-system/tokens';

interface User {
  id: string;
}

interface MobileMenuButtonProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
  headerOnLight: boolean;
  user: User | null;
  newInquiryCount: number;
  t: (namespace: string, key: string, fallback: string) => string;
}

export const MobileMenuButton = memo(
  ({
    mobileMenuOpen,
    setMobileMenuOpen,
    headerOnLight,
    user,
    newInquiryCount,
    t,
  }: MobileMenuButtonProps) => {
    return (
      <Button
        variant="ghost"
        size="icon"
        radius="xl"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className={`lg:hidden relative transition-colors duration-300 ${SIZE_SCALE.w8} ${SIZE_SCALE['8']} sm:${SIZE_SCALE.w9} sm:${SIZE_SCALE['9']} ${
          headerOnLight
            ? `${COLOR_SCALE.foreground} hover:${COLOR_SCALE['foreground-muted']} hover:${COLOR_SCALE['surface-subtle']}`
            : `text-white hover:text-white/80 hover:${COLOR_SCALE.surface}/20`
        }`}
        aria-label={t('aria', 'open_menu', 'Open menu')}
      >
        <Menu className={`${SIZE_SCALE.iconMd}`} aria-hidden="true" />
        {user && newInquiryCount > 0 && (
          <Badge
            className={`absolute -top-1 -right-1 ${COLOR_SCALE['red-600-bg']} text-white ${TYPE_SCALE['3xs']} ${SIZE_SCALE.w4} ${SIZE_SCALE['4']} flex items-center justify-center ${SURFACE_PADDING.none} ${RADIUS_SCALE.full}`}
          >
            {newInquiryCount}
          </Badge>
        )}
      </Button>
    );
  }
);

MobileMenuButton.displayName = 'MobileMenuButton';
